module.exports = __webpack_public_path__ + "media/src/images/posters_points-6e2876de8bbf3542c8918becc2beaca6.png";